<template>
  <div>
    <v-layout class="mb-5" row wrap>
      <v-flex xs7>
        <div style="margin-top: 10px">{{ $t('บอทตอบกลับนอกเวลาทำการแอดมิน') }}</div>
      </v-flex>
      <template v-if="!isEdit">
        <v-flex xs5 class="text-xs-right">
          <v-btn icon outline color="primary" @click="showEdit">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs7>
          <div class="form-control">
            <AutoresizeTextarea v-model="message" :disabled="true"></AutoresizeTextarea>
          </div>
        </v-flex>
      </template>
      <v-flex v-else xs7>
        <div class="form-control">
          <AutoresizeTextarea v-model="input.message"></AutoresizeTextarea>
        </div>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="isEdit = false">cancel</v-btn>
          <v-btn :loading="saveloading" depressed color="primary" @click="saveData">save</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
export default {
  computed: {
    ...mapGetters(['selectedBot', 'setting'])
  },
  components: { AutoresizeTextarea },
  data() {
    return {
      isEdit: false,
      saveloading: false,
      message: '',
      input: {
        message: ''
      }
    }
  },
  mounted() {
    if (this.setting.hasOwnProperty('after_hours_message')) {
      this.message = JSON.parse(this.setting['after_hours_message'].contentvalue)[0][0].text
    }
    //   this.setting =
  },
  methods: {
    showEdit() {
      this.input.message = this.message
      this.isEdit = true
    },
    saveData() {
      var data = {
        pageid: this.selectedBot.pageid,
        afterHoursMessage: [[{ type: 'text', text: this.input.message }]]
      }
      this.saveloading = true
      api.com7PostAnswerAfterHours(data, (err, response) => {
        this.message = this.input.message
        this.saveloading = false

        this.isEdit = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/Ticket2AdminDefaultMessage.vue